import Backbone from 'backbone';
import { View } from 'backbone.marionette';
// import Syphon from 'backbone.syphon';
import _ from 'underscore';

import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import ReloadViewModule from '../../../services/ReloadViewModule';
import OrderDeviceSectionView from '../../../views/OrderDeviceSectionView';
import SaveCustomerOrderDevices from '../../../services/SaveCustomerOrderDevices';

import tmplDesktopFormView from './DesktopFormView.hbs';

const DesktopFormView = View.extend({
  template: tmplDesktopFormView,

  className: 'desktop-form-view',

  ui: {
    descriptionSection: '.description-section',
    printerSection: '.printer-section',
    tonerSection: '.toner-section',
    scannerSection: '.scanner-section',
    devicesAlert: '.no-devices-error'
    // itemQuantity: '.item-quantity'
  },

  regions: {
    descriptionSection: '@ui.descriptionSection',
    printerSection: '@ui.printerSection',
    tonerSection: '@ui.tonerSection',
    scannerSection: '@ui.scannerSection'
  },

  events: {
    'change @ui.itemQuantity': 'onItemQuantityChange'
  },

  onBeforeRender() {
    const formData = Object.assign({}, this.model.get('existingFormData'));
    _.forEach(this.model.get('lineItems'), (result) => {
      let quantity;
      if (result.model) {
        quantity = formData[result.model];
      } else if (result.laserPrinterTonerCartridgeType) {
        quantity = formData[result.laserPrinterTonerCartridgeType.concat('--', result.clin)];
      }

      if (!quantity) {
        return;
      }
      result.totalCost = result.price * quantity;
    });
  },

  onRender() {
    const { Printer, Scanner, Toner } = _.groupBy(this.model.get('lineItems'), 'panel');
    const orderType = this.model.get('orderDetails').orderTypeId;
    const isAdminEdit = this.model.get('orderDetails').isAdminEdit;

    this.orderDeviceSectionView = new OrderDeviceSectionView();
    this.showChildView(
      'printerSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: Printer,
          title: 'Desktop Multifunction Printer',
          id: 'printer',
          orderType,
          isAdminEdit
        })
      })
    );
    this.showChildView(
      'scannerSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({ lineItems: Scanner, title: 'Desktop Scanner', id: 'scanner', orderType, isAdminEdit })
      })
    );
    this.showChildView(
      'tonerSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({ lineItems: Toner, title: 'Printer Toner Cartridge', id: 'toner', orderType, isAdminEdit })
      })
    );

    let contract;
    orderType === '10' ? (contract = 'Guam VB0') : (contract = 'VB0');
    this.showChildView(
      'descriptionSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          title: 'Device Information',
          type: 'description',
          id: 'description',
          contract,
          isAdminEdit
        })
      })
    );
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occurred while saving devices for this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  },

  async validate() {
    const printerColl = await this.getChildView('printerSection').getDeviceData();
    const scannerColl = await this.getChildView('scannerSection').getDeviceData();
    const tonerColl = await this.getChildView('tonerSection').getDeviceData();
    let isValid = true;
    if (!printerColl?.totalPrinterQuantity && !scannerColl?.totalScannerQuantity && !tonerColl?.totalTonerQuantity) {
      isValid = false;
      this.ui.devicesAlert.show();
    }
    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  async onSave() {
    this.ui.devicesAlert.hide();
    this.trigger('no:errors');
    const printerColl = await this.getChildView('printerSection').getDeviceData();
    const scannerColl = await this.getChildView('scannerSection').getDeviceData();
    const tonerColl = await this.getChildView('tonerSection').getDeviceData();
    const totalPrinterPrice = printerColl?.totalPrinterPrice || 0;
    const totalPrinterQuantity = printerColl?.totalPrinterQuantity || 0;
    const totalScannerPrice = scannerColl?.totalScannerPrice || 0;
    const totalScannerQuantity = scannerColl?.totalScannerQuantity || 0;
    const totalTonerPrice = tonerColl?.totalTonerPrice || 0;
    const totalTonerQuantity = tonerColl?.totalTonerQuantity || 0;
    const totalOrderPrice = totalPrinterPrice + totalScannerPrice + totalTonerPrice;
    const totalOrderQuantity = totalPrinterQuantity + totalScannerQuantity + totalTonerQuantity;
    const orderFormData = {
      totalOrderPrice,
      totalOrderQuantity,
      totalPrinterPrice,
      totalPrinterQuantity,
      totalScannerPrice,
      totalScannerQuantity,
      totalTonerPrice,
      totalTonerQuantity
    };
    const devicesFormData =
      printerColl?.changedItems?.concat(scannerColl?.changedItems || [], tonerColl?.changedItems || []) || [];

    const formData = {
      devicesFormData,
      orderFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId
    };

    try {
      await SaveCustomerOrderDevices(formData);
      await ReloadViewModule.reload();
      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  }
});

export default DesktopFormView;
